import React from 'react'
import { Col, Grid, Row, Skeleton } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Billing/subcomponents/Placeholder/Placeholder.module.scss'

const Placeholder = () => {
  const breakpoints = useBreakpoint()

  return (
    <Skeleton shown className={styles.skeleton}>
      {!breakpoints.md ? (
        <Grid>
          <Row className={styles.skeleton__row} style={{ marginBottom: 23 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 13 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '75%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 12 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: 105, height: 62, marginRight: 12 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 105, height: 62, marginRight: 12 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 105, height: 62 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 83 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: 105, height: 62, marginRight: 12 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 105, height: 62, marginRight: 12 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 105, height: 62 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 56 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 112 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row
            className={styles.skeleton__row}
            justifyContent="end"
            style={{ marginBottom: 20 }}
          >
            <Col
              className={styles.skeleton__line}
              style={{ width: '58%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row
            className={styles.skeleton__row}
            justifyContent="end"
            style={{ marginBottom: 87 }}
          >
            <Col
              className={styles.skeleton__line}
              style={{ width: '34%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 22 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 54 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 22 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 54 }}
              sm="auto"
            />
          </Row>
        </Grid>
      ) : (
        <Grid>
          <Row className={styles.skeleton__row} style={{ marginBottom: 23 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '47%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 23 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '47%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 13 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70, marginRight: 13 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70, marginRight: 13 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70, marginRight: 13 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 60 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70, marginRight: 13 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70, marginRight: 13 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70, marginRight: 13 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: 120, height: 70 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 112 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 56 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row
            className={styles.skeleton__row}
            style={{ marginBottom: 20 }}
            justifyContent="between"
          >
            <Col
              className={styles.skeleton__line}
              style={{ width: '21%', height: 19 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: '36%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row
            className={styles.skeleton__row}
            style={{ marginBottom: 61 }}
            justifyContent="end"
          >
            <Col
              className={styles.skeleton__line}
              style={{ width: '21%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} justifyContent="between">
            <Col
              className={styles.skeleton__line}
              style={{ width: '37%', height: 54 }}
              sm="auto"
            />
            <Col
              className={styles.skeleton__line}
              style={{ width: '59%', height: 54 }}
              sm="auto"
            />
          </Row>
        </Grid>
      )}
    </Skeleton>
  )
}

export default Placeholder
